import useItemDetails from '@/features/VOD/hooks/useItemDetails'
import useChannelChangeHook from '@/components/tv/hooks/useChannelChangeHook'
import { useTVStore, useVODStore } from '@/shared/store'
import { useEffect } from 'react'
import {
    channelType,
    cutvType,
    VodPageDetailsType,
    vodType,
} from '@/shared/constants'
import { useTopMenu } from '@/widgets/TopMenu/hooks/useTopMenu'
import { useSearchParams } from 'react-router-dom'
import {
    selectSetItemDetails,
    selectSetVodPages,
} from '@/shared/store/storeSelectors/vodSelectors'
import { selectChannelsData } from '@/shared/store/storeSelectors/tvSelectors'

export const useHandleContentWithLinkParams = () => {
    const [searchParams] = useSearchParams()

    const channelsData = useTVStore(selectChannelsData)
    const setVodPages = useVODStore(selectSetVodPages)
    const setItemDetails = useVODStore(selectSetItemDetails)

    const { handleChannelChange } = useChannelChangeHook()
    const { handleTvClick, handleVodClick } = useTopMenu()
    const { getItemDetails, details } = useItemDetails()

    const productId = searchParams.get('id')
    const assetType = searchParams.get('type')

    useEffect(() => {
        if (productId && assetType) {
            if (assetType === vodType) {
                getItemDetails({
                    productId,
                    assetType,
                    id: productId,
                })
            } else if (assetType === cutvType) {
                getItemDetails({
                    productId: `${assetType}:${productId}`,
                    assetType,
                    id: `${assetType}:${productId}`,
                })
            } else if (assetType === channelType) {
                const channel = channelsData.find(
                    (channel) => channel.id === productId
                )
                if (channel) {
                    handleTvClick()
                    handleChannelChange(channel)
                    // navigate('/tv', { replace: true })
                }
            }
        }
    }, [productId, assetType, channelsData.length])

    useEffect(() => {
        if (!details) return
        const { productId, productType, title } = details || {}

        if (productId && productType) {
            handleVodClick(true)
            setVodPages(productId, title, VodPageDetailsType)
            setItemDetails({
                productId,
                trailerId: `trailer${productId}`,
                assetType: productType,
                id: `${productId}`,
                offers: details?.offers?.length ? details.offers : [],
            })
        }
    }, [details?.productId])
}
